import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";
import { ProjectTask } from "tekkr-common/dist/model/project/project";

interface Options {
    onSuccess: () => void;
}

type TaskState = ProjectTask["status"];
type TaskUpdate = { status: TaskState } | { assignee: string | null };

interface Input {
    taskId: string;
    update: TaskUpdate;
}

export function useUpdateProjectTaskMutation(options?: Options) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateProjectTask({
                params: {
                    projectId: project.id,
                    taskId: input.taskId,
                },
                body: input.update,
            });

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["project", project.id, "tasks"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["project", project.id, "progress"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["project", project.id, "next-step-suggestion"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["project-list"],
                }),
            ]);
        },
        onSuccess: options?.onSuccess,
    });
}
